module.exports = __webpack_public_path__ + "static/img/home_3.6417481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_3.png
// module id = kbTp
// module chunks = 1